"use client"

import { getSalesChannelInfo } from "@/lib/data/sales-channes"
import { useEffect, useState } from "react"

const StoreServiceEmail = () => {
  const [serviceEmail, setServiceEmail] = useState("")

  useEffect(() => {
    const fetchServiceEmail = async () => {
      let email = localStorage.getItem("serviceEmail")
      if (!email) {
        try {
          const salesChannelInfo = (await getSalesChannelInfo()) as {
            data: { store_service_email: string }
          }
          email = salesChannelInfo?.data?.store_service_email || ""
          if (email) {
            localStorage.setItem("serviceEmail", email)
          }
        } catch (error) {
          console.error("Failed to fetch sales channel info:", error)
          email = ""
        }
      }
      setServiceEmail(email || "")
    }

    fetchServiceEmail()
  }, [])

  if (!serviceEmail) {
    return null
  }

  return (
    <li>
      <a
        href={`mailto:${serviceEmail}`}
        className="transition-colors hover:text-gray-700"
      >
        Email
      </a>
    </li>
  )
}

export default StoreServiceEmail